// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"753":"bcd2fe37","764":"5e832347","869":"225bd4cb"}[chunkId] + ".chunk.js";
};